import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SHOPCARDSBLOCK_LEGACY_FIELD_ORDER = [
  "template_layout",
  "background_color",
  "heading_color",
  { type: 'separator' },
  "title",
  "title_size",
  "layout",
  "max_columns",
  "bottom-margin",
  { type: 'separator' },
  "kioskLayout",
  "kioskCardAspectRatio",
  { type: 'separator' },
  "entity_image_type",
  "display_entity_addresses",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  shopCardsBlockDescriptor: _generatedShopCardsBlockDescriptor,
  shopCardsBlockBlocDefinition,
  shopCardsBlockDashboardLayout,
  shopCardsBlockConfig,
  shopCardsBlockResolveConfig,
  shopCardsBlockProperties,
} = doodBlockConfig(
  {
    name: "Shop cards",
    componentType: 'ShopCardsBlockComponent',
    category: 'catalog',
    description: "Shop cards.",
    keywords: [],
    allowedIn: [
      { bloc: '*Page', slot: '*' },
    ],
    sharedFields: {}
,
    slots: [
      {
        key: 'shops',
        name: "pages.blocks.shop-cards.shops.label",
        accept: 'explicitOnly',
        allowedTypes: ["ShopCardBlock", "HighlightCardBlock", "ShopCardWithLogoBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    template_layout: propertyValue({
      type: 'select',
      value: "default",
      options: {
        label: "pages.blocks.shop-cards.template-layout.label",
        help: "pages.blocks.shop-cards.template-layout.help",
        choices: [
          {
            value: "default",
            label: "pages.blocks.shop-cards.template-layout.options.default",
          },
          {
            value: "hero",
            label: "pages.blocks.shop-cards.template-layout.options.hero",
          }
        ]
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"transparent"},
      options: {
        label: "pages.blocks.shop-cards.background-color.label",
      }
    }),
    heading_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"primary-900"},
      options: {
        label: "pages.blocks.shop-cards.heading-color.label",
      }
    }),
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.shop-cards.title.label",
        help: "pages.blocks.shop-cards.title.help",
      }
    }),
    title_size: propertyValue({
      type: 'select',
      value: "M",
      options: {
        label: "pages.blocks.shop-cards.title-size.label",
        choices: [
          {
            value: "XS",
            label: "pages.blocks.shop-cards.title-size.options.XS",
          },
          {
            value: "S",
            label: "pages.blocks.shop-cards.title-size.options.S",
          },
          {
            value: "M",
            label: "pages.blocks.shop-cards.title-size.options.M",
          },
          {
            value: "L",
            label: "pages.blocks.shop-cards.title-size.options.L",
          }
        ]
      }
    }),
    layout: propertyValue({
      type: 'select',
      value: "col-1",
      options: {
        label: "pages.blocks.shop-cards.layout.label",
        help: "pages.blocks.shop-cards.layout.help",
        choices: [
          {
            value: "col-1",
            label: "pages.blocks.shop-cards.layout.options.col-1",
          },
          {
            value: "col-2",
            label: "pages.blocks.shop-cards.layout.options.col-2",
          }
        ]
      }
    }),
    max_columns: propertyValue({
      type: 'select',
      value: "auto",
      options: {
        label: "pages.blocks.shop-cards.max-columns.label",
        help: "pages.blocks.shop-cards.max-columns.help",
        choices: [
          {
            value: "auto",
            label: "pages.blocks.shop-cards.max-columns.options.auto",
          },
          {
            value: "col-1",
            label: "pages.blocks.shop-cards.max-columns.options.col-1",
          },
          {
            value: "col-2",
            label: "pages.blocks.shop-cards.max-columns.options.col-2",
          },
          {
            value: "col-3",
            label: "pages.blocks.shop-cards.max-columns.options.col-3",
          }
        ]
      }
    }),
    "bottom-margin": propertyValue({
      type: 'select',
      value: "medium",
      options: {
        label: "pages.blocks.shop-cards.bottom-margin.label",
        choices: [
          {
            value: "none",
            label: "pages.blocks.shop-cards.bottom-margin.options.none",
          },
          {
            value: "small",
            label: "pages.blocks.shop-cards.bottom-margin.options.small",
          },
          {
            value: "medium",
            label: "pages.blocks.shop-cards.bottom-margin.options.medium",
          },
          {
            value: "large",
            label: "pages.blocks.shop-cards.bottom-margin.options.large",
          }
        ]
      }
    }),
    kioskLayout: propertyValue({
      type: 'select',
      value: "col-3",
      options: {
        label: "pages.blocks.shop-cards.kiosk-layout.label",
        choices: [
          {
            value: "col-1",
            label: "pages.blocks.shop-cards.kiosk-layout.options.col-1",
          },
          {
            value: "col-2",
            label: "pages.blocks.shop-cards.kiosk-layout.options.col-2",
          },
          {
            value: "col-3",
            label: "pages.blocks.shop-cards.kiosk-layout.options.col-3",
          },
          {
            value: "col-4",
            label: "pages.blocks.shop-cards.kiosk-layout.options.col-4",
          },
          {
            value: "col-5",
            label: "pages.blocks.shop-cards.kiosk-layout.options.col-5",
          },
          {
            value: "col-6",
            label: "pages.blocks.shop-cards.kiosk-layout.options.col-6",
          }
        ]
      }
    }),
    kioskCardAspectRatio: propertyValue({
      type: 'text',
      value: '16/9',
      options: {
        label: "pages.blocks.shop-cards.kiosk-card-aspect-ratio.label",
        help: "pages.blocks.shop-cards.kiosk-card-aspect-ratio.help",
      }
    }),
    entity_image_type: propertyValue({
      type: 'select',
      value: "cover",
      options: {
        label: "pages.blocks.shop-cards.entity-image-type.label",
        help: "pages.blocks.shop-cards.entity-image-type.help",
        choices: [
          {
            value: "cover",
            label: "pages.blocks.shop-cards.entity-image-type.options.cover",
          },
          {
            value: "overview",
            label: "pages.blocks.shop-cards.entity-image-type.options.overview",
          }
        ]
      }
    }),
    display_entity_addresses: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.shop-cards.display-entity-addresses.label",
      },
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.shop-cards.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.shop-cards.fieldset.layout.label",
            fields: [
              "template_layout",
              "layout",
              "max_columns",
              "bottom-margin",
              "background_color",
            ],
          },
          {
            legend: "pages.blocks.shop-cards.fieldset.title.label",
            fields: ["title", "title_size", "heading_color"],
          },
          {
            legend: "pages.blocks.shop-cards.fieldset.shops.label",
            fields: ["shops", "entity_image_type", "display_entity_addresses"],
          },
          {
            legend: "pages.blocks.shop-cards.fieldset.kiosk.label",
            fields: ["kioskLayout", "kioskCardAspectRatio"],
          },
        ],
      },
    ],
  })
);

export function shopCardsBlockDescriptor(): IBlockDescriptor;
export function shopCardsBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopCardsBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopCardsBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopCardsBlockDescriptor, shopCardsBlockProperties, fieldOrder);
}

export {
  shopCardsBlockBlocDefinition,
  shopCardsBlockDashboardLayout,
  shopCardsBlockProperties,
  shopCardsBlockConfig,
  shopCardsBlockResolveConfig,
};

export type ShopCardsBlockConfig = typeof shopCardsBlockConfig;
